import { Coupon } from "../models/inventory/Coupon";
import { CouponFilters } from "../models/inventory/CouponsFilters";
import {
  APIBlobResponse,
  APIResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import { getAPI, downloadCSV, postAPI, putAPI } from "./Networking";

export default class CouponsAPI {
  parseFilters = (filters: CouponFilters): URLSearchParams => {
    const queryParams = new URLSearchParams();

    if (filters.page_no)
      queryParams.append("page_no", filters.page_no.toString());

    if (filters.limit) queryParams.append("limit", filters.limit.toString());

    if (filters.search_text)
      queryParams.append("search_text", filters.search_text.toString());

    if (filters.order_id)
      queryParams.append("order_id", filters.order_id.toString());

    if (filters.inventory_id)
      queryParams.append("inventory_id", filters.inventory_id.toString());

    if (filters.customer_id)
      queryParams.append("customer_id", filters.customer_id.toString());

    if (filters.status) queryParams.append("status", filters.status.toString());

    if (filters.active) queryParams.append("active", filters.active.toString());

    if (filters.is_onelink !== undefined)
      queryParams.append("is_onelink", filters.is_onelink.toString());

    if (filters.sort_by)
      queryParams.append("sort_by", filters.sort_by.toString());

    if (filters.sort_type)
      queryParams.append("sort_type", filters.sort_type.toString());

    return queryParams;
  };

  getCoupons = async (
    filters: CouponFilters,
    downloadReport: boolean
  ): Promise<PaginatedAPIResponse<Coupon> | APIBlobResponse> => {
    try {
      const queryParams = this.parseFilters(filters);

      if (downloadReport) {
        queryParams.append("download_report", true.toString());
        const response = await downloadCSV(
          `/v5/coupons?${queryParams.toString()}`
        );
        return response;
      } else {
        const response = await getAPI(`/v5/coupons?${queryParams.toString()}`);

        return response.result;
      }
    } catch (error) {
      throw error;
    }
  };

  getCouponsShipments = async (
    filters: CouponFilters,
    downloadReport: boolean
  ): Promise<PaginatedAPIResponse<Coupon> | APIBlobResponse> => {
    try {
      const queryParams = this.parseFilters(filters);
      const response = await downloadCSV(
        `/v5/coupons/download-shipments-report?${queryParams.toString()}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  sendReminders = async (couponIds: number[]): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/coupons/send-reminders`, {
        coupon_id: couponIds,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  reactivateCoupons = async (
    filters: CouponFilters,
    couponIds: number[]
  ): Promise<APIResponse> => {
    try {
      const queryParams = this.parseFilters(filters);

      const response = await putAPI(
        `/v5/coupons/reactivate?${queryParams.toString()}`,
        {
          coupon_ids: couponIds,
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  expireCoupons = async (
    filters: CouponFilters,
    couponIds: number[]
  ): Promise<APIResponse> => {
    try {
      const queryParams = this.parseFilters(filters);

      const response = await putAPI(
        `/v5/coupons/expire?${queryParams.toString()}`,
        {
          coupon_ids: couponIds,
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };
}
